import React from "react";

interface IProps {
  height?: number;
  width?: number;
  color?: string;
}

export const Link: React.FC<IProps> = ({ height, width, color = "#000000" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M16.6372 16.13L13.5 16.13L13.5 14.63L16.6372 14.63C18.0897 14.63 19.2672 13.4525 19.2672 12C19.2672 10.5475 18.0897 9.36999 16.6372 9.36999L13.5 9.36999L13.5 7.86999L16.6372 7.86999C18.9181 7.86999 20.7672 9.71906 20.7672 12C20.7672 14.2809 18.9181 16.13 16.6372 16.13Z"
          fill={color}/>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M7.36279 7.87L10.5 7.87001L10.5 9.37001L7.36279 9.37C5.91028 9.37 4.73279 10.5475 4.73279 12C4.73279 13.4525 5.91028 14.63 7.36279 14.63L10.5 14.63L10.5 16.13L7.36279 16.13C5.08186 16.13 3.23279 14.2809 3.23279 12C3.23279 9.71907 5.08186 7.87 7.36279 7.87L7.36279 8.59581L7.36279 7.87Z"
          fill={color}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.5 11.25L16.5 11.25L16.5 12.75L7.5 12.75L7.5 11.25Z"
          fill={color}/>
  </svg>
);
